/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/card_in_medium'
export default icon
